import { ServicesUI } from "../../components/services/ServicesUI";
import { useServicesData } from "../../hooks/useServicesData";
import "../../css/services.css";

const BusinessesPage = () => {
    const servicesData = useServicesData("business");

    return (
        <ServicesUI
            {...servicesData}
            pageTitle="Businesses"
        />
    );
};

export default BusinessesPage;